export default "__VITE_PUBLIC_ASSET__43ab9ae8__"